<template>
  <div class="contact-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('contact_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-account-cash</v-icon>{{$t('contact.contacts')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <ContactFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
          <template slot="item.comptehub" slot-scope="{ item }">
            <strong v-if="item.comptehub" >
              <v-icon color="green">mdi-check-circle</v-icon>
            </strong>
            <span v-else>
              <v-icon color="red">mdi-close-circle</v-icon>
            </span>
          </template>
            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import ContactFilterForm from '../../components/contact/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'ContactList',
  servicePrefix: 'Contact',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    ContactFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.name'), value: 'name' },
        { text: this.$t('contact.customer'), value: 'customer.name' },
        { text: this.$t('contact.email'), value: 'email' },
        { text: this.$t('contact.phone'), value: 'phone' },
        { text: this.$t('contact.comptehub'), value: 'comptehub' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['firstname','lastname'], sortDesc : [false,false]}
    };
  },
  computed: {
    ...mapGetters('contact', {
      items: 'list'
    }),
    ...mapFields('contact', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('contact', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
